import React, { useEffect, useState } from "react";
import "./MainScreen.css";
import { WelcomeSection } from "../../components/welcome-section/WelcomeSection";
import { ReelSection } from "../../components/reel-section/ReelSection";
import { SecondReelSection } from "../../components/reel-section/second-reel/SecondReelSection";
import { preloadImagesAsync } from "../../components/utils/preloadImagesAsync";
import { ThirdReel } from "../../components/reel-section/third-reel/ThirdReel";
import { FourthSection } from "../../components/reel-section/fourth-reel/FourthSection";
import { FifthSection } from "../../components/reel-section/fifth-section/FifthSection";
import { GallerySection } from "../../components/reel-section/gallery-section/GallerySection";
import { Guestbook } from "../../components/reel-section/guestbook-section/Guestbook";
import { RSVPSection } from "../../components/reel-section/rsvp-section/RSVPSection";
import { TextSection } from "../../components/reel-section/text-section/TextSection";
import { SixthSection } from "../../components/reel-section/sixth-section/SixthSection";
import firstImage from "../../assets/img/reel-section/sixth-section/main-image.png";
import secondImage from "../../assets/img/reel-section/sixth-section/second-image.png";

import { NoAttendanceConfirmation } from "../../components/no-attendance/NoAttendanceConfirmation";
import { GuestListClosed } from "../../components/guestlist-closed/GuestListClosed";
import { useGuest } from "../../contexts/GuestContext";
import { useNavigate } from "react-router-dom";

import { ImgContainer } from "../../components/reel-section/sixth-section/ImgContainer";
import { allPreloadImages } from "../../components/utils/preloadImagesList";

export const MainScreen: React.FC = () => {
  const [showWelcome, setShowWelcome] = useState(true);
  const [startTransition, setStartTransition] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const navigate = useNavigate();
  const { token, guest, isGuestLoaded } = useGuest();
  const [isWelcomeLoaded, setIsWelcomeLoaded] = useState(false);

  useEffect(() => {
    if (!isGuestLoaded) return;

    if (!guest) {
      navigate("/not-authorized");
    } else {
      setIsAuthorized(true);
    }
  }, [isGuestLoaded, guest, navigate]);

  useEffect(() => {
    if (!isAuthorized || !isWelcomeLoaded) return;

    preloadImagesAsync(allPreloadImages).then(() => {
      const fadeOutTimer = setTimeout(() => {
        setStartTransition(true);
      }, 2000);

      const hideWelcomeTimer = setTimeout(() => {
        setShowWelcome(false);
      }, 3000);

      return () => {
        clearTimeout(fadeOutTimer);
        clearTimeout(hideWelcomeTimer);
      };
    });
  }, [isAuthorized, isWelcomeLoaded]);

  if (!isGuestLoaded || !isWelcomeLoaded) {
    return (
      <div className="main-container">
        <div className="fade-screen">
          <WelcomeSection onLoad={() => setIsWelcomeLoaded(true)} />
        </div>
      </div>
    );
  }

  return (
    <div className="main-container">
      {showWelcome ? (
        <div className={`fade-screen ${startTransition ? "fade-out" : ""}`}>
          {showWelcome && <WelcomeSection />}
        </div>
      ) : null}

      <div className={`reel-welcome-section ${!showWelcome ? "fade-in" : ""}`}>
        {!showWelcome ? (
          <div style={{ flex: 1 }}>
            {/* <SpinnerOverlay /> */}
            <ReelSection />
            <SecondReelSection />
            <TextSection />
            <ThirdReel />
            <FourthSection />
            <FifthSection />
            <GallerySection />
            <Guestbook />
            <SixthSection img={firstImage} />
            {guest?.hasConfirmed ? (
              guest.confirmed === 0 ? (
                <NoAttendanceConfirmation />
              ) : (
                <RSVPSection showQRModal />
              )
            ) : (
              <RSVPSection />
            )}
            <ImgContainer img={secondImage} />
            {/* <GuestListClosed /> */}
          </div>
        ) : null}
      </div>
    </div>
  );
};
